import { render } from "./InstantGratification.vue?vue&type=template&id=d101822a&scoped=true"
import script from "./InstantGratification.vue?vue&type=script&lang=js"
export * from "./InstantGratification.vue?vue&type=script&lang=js"

import "./InstantGratification.vue?vue&type=style&index=0&id=d101822a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d101822a"]])

export default __exports__